/**
 * Checks if the user prefers reduced motion based on their system settings
 * @returns true if the user prefers reduced motion, false otherwise
 */
export const prefersReducedMotion = (): boolean => {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
